<template>
  <div class="followup-container">
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    
    <v-card class="mb-5" outlined>
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="2" class="mb-1">
              <div class="text-h6">Patients Followup</div>
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                  :items="doctors"
                  item-text="dr_name"
                  item-key="id"
                  label="Doctor List"
                  v-on:change="getReports()"
                  v-model="searchParam.doctor"
                  return-object
                  :loading="isLoading"
                  outlined
                  dense
                  hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      label="Followup Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </template>

                <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                    @click:date="dateSelect"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-row align="center" justify="center">
                <v-col cols="auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          v-on="on"
                          class="ms-2"
                          color="primary"
                          v-on:click="printList"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Print Followup</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>

    <div id="print">
      <v-card class="mb-5" outlined>
        <v-card-title class="text-h6">Prescription Patients: Followup</v-card-title>
        <v-data-table
            :headers="headers"
            :items="dessertsItemsWithSno"
            class="elevation-1"
            :search="search"
            dense
            mobile-breakpoint="0"
            :loading="loadingstatus"
            loading-text="Loading... Please wait"
            disable-pagination
            :hide-default-footer="true"
        >
          <template v-slot:item.followupStatus="{ item }">
            <v-chip v-if="item.followup_status == 1" dark color="green" label outlined small>Done
            </v-chip>
            <v-chip v-if="item.followup_status == 0" dark color="orange" label outlined small>Pending
            </v-chip>
          </template>
          <template v-slot:item.patient_phone="{ item }">
            {{ item.patient.patient_phone }}
            <v-chip v-if="item.patient.contact_person">{{ item.patient.contact_person }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    @click="getReSchedule(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ma-2"
                    open
                    prepend-icon="mdi-printer"
                    color="primary"
                    label
                    outlined
                    small
                >
                  <v-icon> mdi-plus</v-icon>
                </v-chip>
              </template>
              <span>Add Comments</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getReports">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-card class="mb-5" outlined>
        <v-card-title class="text-h6">Patient Followup</v-card-title>
        <v-data-table
            :headers="followUpHeaders"
            :items="followUpDessertsItemsWithSno"
            class="elevation-1"
            :search="search"
            dense
            mobile-breakpoint="0"
            :loading="loadingstatus"
            loading-text="Loading... Please wait"
            disable-pagination
            :hide-default-footer="true"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    @click="editReSchedule(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ma-2"
                    open
                    prepend-icon="mdi-printer"
                    color="primary"
                    label
                    outlined
                    small
                >
                  <v-icon> mdi-pencil</v-icon>
                </v-chip>
              </template>

              <span>Edit Comments</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                    @click="deleteSchedule(item)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ma-2"
                    open
                    prepend-icon="mdi-printer"
                    color="red"
                    label
                    outlined
                    small
                >
                  <v-icon> mdi-delete-outline</v-icon>
                </v-chip>
              </template>
              <span>Delete Comments</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="getReports">Reset</v-btn>
          </template>
        </v-data-table>
        <v-col cols="12" sm="6" class="pa-4">
          <v-card-title class="text-h6">Summary</v-card-title>
          <v-simple-table dense>
            <tbody>
            <tr>
              <td>Total Patient</td>
              <td>{{ desserts.length }}</td>
            </tr>
            <tr v-for="item in followup_summary" :key="item.id">
              <td>{{ item.followup_type }}</td>
              <td>{{ item.count }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-card>
    </div>

    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5">Schedule Follow-up</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container v-if="reschedule">
            <v-row>
              <v-col cols="12" sm="6">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-subtitle-1 font-weight-bold mb-1">
                      {{ reschedule.patient.patient_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>ID: {{ reschedule.patient.patient_id }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Phone: {{ reschedule.patient.patient_phone }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                    v-model="reschedule.followup_type"
                    :items="followup_type"
                    label="Follow-up Type*"
                    dense
                    outlined
                    :rules="[formRules.required]"
                ></v-select>

                <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="reschedule.followup_date"
                        label="Follow-up Date*"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[formRules.date]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="reschedule.followup_date"
                      @input="menu3 = false"
                      :min="new Date().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>

                <v-textarea
                    v-model="reschedule.comments"
                    label="Comments"
                    outlined
                    dense
                    rows="3"
                    counter
                    maxlength="500"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <div v-if="spinnerButtons">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </div>
          <div v-else>
            <v-btn
                text
                @click="closeDialog"
                :disabled="spinnerButtons"
            >
              Cancel
            </v-btn>
            <v-btn
                color="primary"
                @click="formSubmit"
                :disabled="spinnerButtons"
                class="ml-2"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5">Edit Follow-up</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-container v-if="reschedule">
            <v-row>
              <v-col cols="12" sm="6">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-subtitle-1 font-weight-bold mb-1">
                      {{ reschedule.patient.patient_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>ID: {{ reschedule.patient.patient_id }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Phone: {{ reschedule.patient.patient_phone }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                    v-model="reschedule.followup_type"
                    :items="followup_type"
                    label="Follow-up Type*"
                    dense
                    outlined
                    :rules="[formRules.required]"
                ></v-select>

                <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="reschedule.followup_date"
                        label="Follow-up Date*"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[formRules.date]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="reschedule.followup_date"
                      @input="menu3 = false"
                      :min="new Date().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>

                <v-textarea
                    v-model="reschedule.comments"
                    label="Comments"
                    outlined
                    dense
                    rows="3"
                    counter
                    maxlength="500"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <div v-if="spinnerButtons">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
          </div>
          <div v-else>
            <v-btn
                text
                @click="closeDialog"
                :disabled="spinnerButtons"
            >
              Cancel
            </v-btn>
            <v-btn
                color="primary"
                @click="editFormSubmit"
                :disabled="spinnerButtons"
                class="ml-2"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      spinnerButtons: false,
      dialog: false,
      editDialog: false,
      menu2: false,
      menu3: false,
      loadingstatus: true,
      isLoading: true,
      search: "",
      doctors: [],
      searchParam: {
        doctor: null,
      },
      followup_type: ["Not Reached", "Appointment Confirm", "Later On", "Feeling Well", "No Need To Come", "The Patient Died", "Wrong Number", "Switched Off", "Hang Up"],
      reschedule: {
        id: null,
        patient: {
          patient_id: '',
          patient_name: '',
          patient_phone: ''
        },
        followup_date: moment().format('YYYY-MM-DD'),
        comments: '',
        followup_type: null,
      },
      formRules: {
        required: v => !!v || 'This field is required',
        date: v => !!v || 'Please select a date'
      },
      headers: [
        {text: "sl", value: "sno",},
        {text: "Patient ID", value: "patient_id"},
        {text: "Patient Name", value: "patient.patient_name",},
        {text: "Patient DOB", value: "patient.patient_dob",},
        {text: "Patient Phone", value: "patient_phone",},
        {text: "Followup Type", value: "followup_type",},
        {text: "Doctor", value: "doctor.dr_name"},
        {text: "Prescription Date", value: "prescription_date"},
        {text: "Followup Date", value: "next_visit"},
        {text: "Followup Status", value: "followupStatus"},
        {text: "Action", value: "actions", sortable: false},
      ],
      desserts: [],
      followup_summary: [],
      followUpHeaders: [
        {
          text: "sl #",
          value: "sno",
        },
        {text: "Patient ID", value: "patient_id"},
        {
          text: "Patient Name",
          value: "patient.patient_name",
        },

        {
          text: "Patient Phone",
          value: "patient.patient_phone",
        },
        {text: "Doctor", value: "doctor.dr_name"},
        {text: "Comments Type", value: "followup_type"},
        {text: "Note", value: "comments"},

        {text: "Date", value: "date"},
        {text: "Followup Date", value: "followup_date"},
        {text: "Action", value: "actions", sortable: false},
      ],
      followUpDesserts: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Prescription",
          disabled: false,
          href: "/prescription/list",
        },
        {
          text: "Folloup Patients",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.getReports();
    this.getDoctors();
    this.getFollowupData();
  },
  computed: {
    dessertsItemsWithSno() {
      return this.desserts.map((d, index) => ({...d, sno: index + 1}));
    },
    followUpDessertsItemsWithSno() {
      return this.followUpDesserts.map((d, index) => ({...d, sno: index + 1}));
    },
  },

  methods: {
    resetForm() {
      this.reschedule = {
        id: null,
        patient: {
          patient_id: '',
          patient_name: '',
          patient_phone: ''
        },
        followup_date: moment().format('YYYY-MM-DD'),
        comments: '',
        followup_type: null,
      }
    },

    getReSchedule(item) {
      this.resetForm()
      this.reschedule = {
        ...item,
        followup_date: moment().format('YYYY-MM-DD'),
        followup_type: null,
        comments: ''
      }
      this.dialog = true
    },

    editReSchedule(item) {
      this.resetForm()
      this.reschedule = {
        ...item,
        followup_date: moment(item.followup_date).format('YYYY-MM-DD')
      }
      this.editDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.resetForm()
    },

    formSubmit() {
      if (!this.reschedule.followup_type || !this.reschedule.followup_date) {
        this.$noty.error('Please fill all required fields')
        return
      }

      this.spinnerButtons = true
      const payload = {
        data: {
          ...this.reschedule,
          followup_date: moment(this.reschedule.followup_date).format('YYYY-MM-DD')
        },
        user_id: localStorage.getItem("userId")
      }

      atshq
          .post("patients/followup", payload)
          .then((response) => {
            this.loadingstatus = false
            this.closeDialog()
            this.$noty.success(response.data.message)
            this.getFollowupData()
            this.getReports()
          })
          .catch((e) => {
            // Fixed: Proper error message handling without optional chaining
            let errorMessage = 'An error occurred';
            if (e.response && e.response.data) {
              errorMessage = e.response.data.message || errorMessage;
            }
            this.$noty.error(errorMessage);
          })
          .finally(() => {
            this.spinnerButtons = false
          })
    },

    editFormSubmit() {
      if (!this.reschedule.followup_type || !this.reschedule.followup_date) {
        this.$noty.error('Please fill all required fields')
        return
      }

      this.spinnerButtons = true
      const payload = {
        data: {
          ...this.reschedule,
          followup_date: moment(this.reschedule.followup_date).format('YYYY-MM-DD')
        },
        user_id: localStorage.getItem("userId")
      }

      atshq
          .put(`patients/followup/${this.reschedule.id}`, payload)
          .then((response) => {
            this.loadingstatus = false
            this.closeDialog()
            this.$noty.success(response.data.message)
            this.getFollowupData()
            this.getReports()
          })
          .catch((e) => {
            // Fixed: Proper error message handling without optional chaining
            let errorMessage = 'An error occurred';
            if (e.response && e.response.data) {
              errorMessage = e.response.data.message || errorMessage;
            }
            this.$noty.error(errorMessage);
          })
          .finally(() => {
            this.spinnerButtons = false
          })
    },

    deleteSchedule(item) {
      if (confirm("are you sure?")) {
        atshq
            .delete("patients/followup/" + item.id)
            .then((response) => {
              // JSON responses are automatically parsed.
              this.loadingstatus = false;
              this.$noty.success(response.data.message);
              this.getFollowupData();
            })
            .catch((e) => {
              // Fixed: Proper error message handling without optional chaining
              let errorMessage = 'An error occurred';
              if (e.response && e.response.data) {
                errorMessage = e.response.data.message || errorMessage;
              }
              this.$noty.error(errorMessage);
            });
      }
    },

    getReports() {
      let drid = this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;
      atshq
          .get("prescriptions/followup-patient?date=" + this.date + "&doctor=" + drid)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
          })
          .catch((e) => {
            // Fixed: Proper error message handling without optional chaining
            let errorMessage = 'An error occurred';
            if (e.response && e.response.data) {
              errorMessage = e.response.data.message || errorMessage;
            }
            this.$noty.error(errorMessage);
          });
      this.getFollowupData();
    },

    getFollowupData() {
      let drid = this.searchParam.doctor !== null ? this.searchParam.doctor.id : null;
      atshq
          .get("patients/followup?date=" + this.date + "&doctor=" + drid)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.followUpDesserts = response.data.data;
            this.followup_summary = response.data.summary;
            // console.log(this.followup_summary);
          })
          .catch((e) => {
            // Fixed: Proper error message handling without optional chaining
            let errorMessage = 'An error occurred';
            if (e.response && e.response.data) {
              errorMessage = e.response.data.message || errorMessage;
            }
            this.$noty.error(errorMessage);
          });
    },

    getDoctors() {
      atshq
          .get("doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            // Fixed: Proper error message handling without optional chaining
            let errorMessage = 'An error occurred';
            if (e.response && e.response.data) {
              errorMessage = e.response.data.message || errorMessage;
            }
            this.$noty.error(errorMessage);
          });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },

    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
      this.getFollowupData();
    },

    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");
      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");
      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>

<style scoped>
.followup-container {
  padding: 16px;
  background-color: whitesmoke;
  min-height: calc(100vh - 64px);
}

.v-card {
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.mb-5 {
  margin-bottom: 20px;
}

.v-chip {
  cursor: pointer;
}

.v-chip:hover {
  opacity: 0.8;
}

.text-h6 {
  font-weight: 500;
}
</style>
